<div class="section-header">
    <div class="title">
        <span>{{title}}</span>
        <app-info-icon-button *ngIf="isInfoIconVisible()" [model]="{ title: 'Information',
                              messages: [this.infoIconText],
                              dialogHeight: 100}">
        </app-info-icon-button>
    </div>
</div>

<div class="table">
    <div class="table-header">
        <div class="table-header-column">Anzahl</div>
        <div class="table-header-column">Artikel</div>
        <div class="table-header-column amounts">
        </div>
    </div>

    <div class="table-body">
        <div class="table-row not-device" *ngFor="let container of tableItems">
            <div class="amount-column-cell">
                <app-amount-input [(ngModel)]="container.waAcLsAmount.amount"
                                  [showIcon]="false"
                                  [name]="container.id + 'amount_aitw'"
                                  disabled>
                </app-amount-input>
            </div>
            <div class="article-column-cell">
                <div class="product-label-container">
                    <app-product-label [orderItemContainer]="container"
                                       [activateHover]="false">
                    </app-product-label>
                </div>

            </div>
        </div>
    </div>
</div>



